import { render, staticRenderFns } from "./taskTable.vue?vue&type=template&id=d200d9d4&scoped=true"
import script from "./taskTable.vue?vue&type=script&lang=js"
export * from "./taskTable.vue?vue&type=script&lang=js"
import style0 from "./taskTable.vue?vue&type=style&index=0&id=d200d9d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d200d9d4",
  null
  
)

export default component.exports